import { buildingStatusLabels, buildingTypeLabels } from "./customerConfig";

/**
 * VIEW_COLUMNS defines the read-only columns for customer table view mode.
 */
export const VIEW_COLUMNS = [
  {
    key: "buildingReference",
    label: "Building Site",
    render: (building) => building.buildingReference || "",
  },
  {
    key: "buildingType",
    label: "Type",
    render: (building) => building.buildingType || "",
  },
  {
    key: "location",
    label: "Location",
    render: (building) =>
      buildingStatusLabels[building.location] || building.location || "",
  },
  {
    key: "buildingStatus",
    label: "Status",
    render: (building) => building.buildingStatus || "",
  },
  {
    key: "activeBalance",
    label: "Balance",
    render: (building) => `$${building.activeBalance || "0.00"}`,
  },
];

/**
 * EDIT_COLUMNS defines the editable columns for customer table in edit mode.
 * Each column can specify a type and, for select fields, a list of options.
 */
export const EDIT_COLUMNS = [
  {
    key: "buildingReference",
    label: "Name",
    type: "text",
  },
  {
    key: "buildingType",
    label: "Type",
    type: "select",
    options: Object.entries(buildingTypeLabels), // Array of [key, label]
  },
  {
    key: "location",
    label: "Location",
    type: "text",
  },
  {
    key: "buildingStatus",
    label: "Status",
    type: "select",
    options: Object.entries(buildingStatusLabels), // Array of [key, label]
  },
  { key: "activeBalance", label: "Balance", type: "text" },
];
